import {
    REQUEST_STATE,

    CORE_GET_MASTERS_REQUEST,
    CORE_GET_MASTERS_SUCCESS,
    CORE_GET_MASTERS_FAILURE,

    CORE_GET_ALL_MYTASKS_REQUEST,
    CORE_GET_ALL_MYTASKS_SUCCESS,
    CORE_GET_ALL_MYTASKS_FAILURE,

    CORE_GET_MYTASK_BY_ID_REQUEST,
    CORE_GET_MYTASK_BY_ID_SUCCESS,
    CORE_GET_MYTASK_BY_ID_FAILURE,

    // CORE_CREATE_MYTASK_REQUEST,
    // CORE_CREATE_MYTASK_SUCCESS,
    // CORE_CREATE_MYTASK_FAILURE,

    // CORE_SUBMIT_TASK_REQUEST,
    // CORE_SUBMIT_TASK_SUCCESS,
    // CORE_SUBMIT_TASK_FAILURE,

    CORE_GET_ALL_MY_ASSIGN_REQUEST,
    CORE_GET_ALL_MY_ASSIGN_SUCCESS,
    CORE_GET_ALL_MY_ASSIGN_FAILURE,

    CORE_GET_ASSIGN_TASK_BY_ID_REQUEST,
    CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS,
    CORE_GET_ASSIGN_TASK_BY_ID_FAILURE,

    // CORE_IN_PROGRESS_TASK_REQUEST,
    // CORE_IN_PROGRESS_TASK_SUCCESS,
    // CORE_IN_PROGRESS_TASK_FAILURE,

    CORE_GET_ALL_MY_DRAFT_REQUEST,
    CORE_GET_ALL_MY_DRAFT_SUCCESS,
    CORE_GET_ALL_MY_DRAFT_FAILURE,

    CORE_GET_DRAFT_TASK_BY_ID_REQUEST,
    CORE_GET_DRAFT_TASK_BY_ID_SUCCESS,
    CORE_GET_DRAFT_TASK_BY_ID_FAILURE,

} from '../types'

const requestState = REQUEST_STATE

export default {
    master: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_MASTERS_REQUEST:
                return state
            case CORE_GET_MASTERS_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_MASTERS_FAILURE:
                return {}
            default:
                return state
        }
    },
    tasks: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_MYTASKS_REQUEST:
            case CORE_GET_ALL_MY_ASSIGN_REQUEST:
            case CORE_GET_ALL_MY_DRAFT_REQUEST:
                return state
            case CORE_GET_ALL_MYTASKS_SUCCESS:
            case CORE_GET_ALL_MY_ASSIGN_SUCCESS:
            case CORE_GET_ALL_MY_DRAFT_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_ALL_MYTASKS_FAILURE:
            case CORE_GET_ALL_MY_ASSIGN_FAILURE:
            case CORE_GET_ALL_MY_DRAFT_FAILURE:
                return []
            default:
                return state
        }
    },
    task: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_MYTASK_BY_ID_REQUEST:
            case CORE_GET_ASSIGN_TASK_BY_ID_REQUEST:
            case CORE_GET_DRAFT_TASK_BY_ID_REQUEST:
                return state
            case CORE_GET_MYTASK_BY_ID_SUCCESS:
            case CORE_GET_ASSIGN_TASK_BY_ID_SUCCESS:
            case CORE_GET_DRAFT_TASK_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_MYTASK_BY_ID_FAILURE:
            case CORE_GET_ASSIGN_TASK_BY_ID_FAILURE:
            case CORE_GET_DRAFT_TASK_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/mytracker.js